export interface IColumnWidth {
    value: number;
    type: 'fr' | 'px';
};

export interface IColumn {
    content: React.ReactNode;
    sortBy?: string;
    sortable?: boolean;
    width: IColumnWidth;
};

export interface IPagination {
    page: number;
    perPage: number;
    onSetPage: (page: number) => void;
    total: number;
};

export interface ISortButton {
    sortBy: string;
    sortedBy?: string;
    sortedByDir?: string;
};

export interface IPaginationButtonProps {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    isActive: boolean;
};

export enum SORT_TYPES {
    ASC = 'asc',
    DESC = 'desc'
};

export enum TABLE_SPACING_VARIANT {
    DEFAULT = 'table-spacing-default',
    SMAll = 'table-spacing-small'
}
